// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Namibia from '../_raw/flag/icon_flag_namibia.png';

export default () => <img src={Namibia} alt="Namibia" />;
